<template>
  <div class="container-fluid">
    <loading :active.sync="isLoading" :is-full-page="false"></loading>
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-flex align-items-center justify-content-between">
          <h4 class="mb-0 font-size-18">Detail {{module}}</h4>
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item">
                <router-link :to="{name:'dashboards'}">Dashboards</router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link :to="{name: table_module}">{{module}}</router-link>
              </li>
              <li class="breadcrumb-item active">detail</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-5">
        <div class="card">
          <div class="card-body">
            <div class="media align-items-center d-flex">
              <div class="media-body overflow-hidden">
                <h5 class="text-truncate font-size-18 mb-1 mt-2">{{data.div_name}}</h5>
              </div>
            </div>

            <h5 class="font-size-15 mt-4">Descriptions</h5>
            <p class="text-muted">{{data.div_description}}</p>

            <hr />
            <div class>
              <h5 class="font-size-14">Total Employee</h5>
              <p class="text-muted mb-0">{{data_emp['total_data']}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-7">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center justify-content-between">
              <h4 class="card-title mb-0">Employee</h4>
              <template v-if="local_users.usr_admin != ''">
                <button
                  type="button"
                  class="btn btn-secondary waves-effect waves-light btn-sm right-bar-toggle"
                  @click="qucikCreateShow(true)"
                >
                  <i class="bx bx-plus mr-2"></i> Employee
                </button>
              </template>
            </div>

            <!-- kalo kosong -->
            <div class="d-flex align-items-center w-100 bg-light mt-3 mb-3 h-350" v-if="data_emp['total_data'] == 0">
              <div class="m-auto text-center mini-stats-wid">
                <div class="mini-stat-icon avatar-sm rounded-circle bg-secondary m-auto">
                  <span class="avatar-title">
                    <i class="bx bx-search-alt font-size-2"></i>
                  </span>
                </div>
                <h5 class="mt-3">No Transactions</h5>
                <p class="mb-0">Please make new a transaction</p>
              </div>
            </div>

            <div class="mt-3">
              <div class="row">
                <div class="col-md-6" v-for="(item, index) in data_emp['data']" :key="index">
                  <div class="card border mb-2">
                    <div class="card-body">
                      <div class="justify-content-between d-flex">
                        <div class="d-flex align-items-center">
                          <img
                            class="rounded-circle details-employee-user mr-3"
                            src="https://asset-a.grid.id/crop/0x0:0x0/700x465/photo/2020/06/17/1855621948.png"
                            alt="Header Avatar"
                          />
                          <div>
                            <h5
                              class="mb-1 font-size-15 text-truncate-employee"
                            >{{item.emp_name}}</h5>
                            <span href="#" class="text-muted text-truncate-employee">{{item.emp_email}}</span>
                          </div>
                        </div>

                        <!-- <div class="dropdown">
                          <button
                            class="btn btn-link dropdown-toggle px-0"
                            type="button"
                            id="dropdownMenuButton"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            <i class="bx bx-dots-vertical-rounded text-dark"></i>
                          </button>
                          <div
                            class="dropdown-menu dropdown-menu-right"
                            aria-labelledby="dropdownMenuButton"
                          >
                            <a class="dropdown-item" href="#">Edit</a>
                            <a class="dropdown-item" href="#">Delete</a>
                          </div>
                        </div> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <quickCreate
      v-if="childDataLoaded"
      :visible="visible"
      :fields="fields_emp"
      module="Employee"
      table_module="employee"
      alias_table="emp"
      @hiddenSideSearch="visible = false"
      @fetch="fetchData"
      :defaultValue="{div_id : data.div_id}"
    ></quickCreate>
  </div>
</template>

<script>
import quickCreate from "@/components/quick_create";

export default {
  data() {
    return {
      visible: false,
      show: 10,
      page: 1,
      isLoading: false,
      module: "Days Off",
      table_module: "day_off",
      alias_table: "day_off",
      uuid: this.$route.params.uuid,
      data: {},
      dataSearch: {},
      childDataLoaded: false,
      fields_emp : {},
      data_emp : {}
    };
  },
  components : {
    quickCreate
  },
  mounted() {
    this.fetchDetail();
  },
  computed: {
    local_users() {
      if (localStorage.getItem("users") != undefined) {
        return JSON.parse(localStorage.getItem("users"));
      }
      return {};
    },
  },
  methods: {
    fetchDetail() {
      this.isLoading = true;
      this.axios
        .get("/" + this.table_module + "/detail/" + this.uuid)
        .then((response) => {
          this.isLoading = false;
          this.data = response.data.data;
          this.fetchData();
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.response) {
            this.$toast.error("Data tidak ada");
            this.$router.push({ name: this.table_module });
          } else if (error.request) {
            console.log("Error", error.message);
          } else {
            console.log("Error", error.message);
          }
        });
    },
    qucikCreateShow(arm) {
      this.visible = arm;
    },
    fetchData(arm) {
      this.fields_emp = {};
      this.visible = false;
      var params = {};
      if (arm == undefined) {
        params = {
          page: this.page,
          show: this.show,
          order_by: this.orderBy,
          type_sort: this.sort,
        };
      } else {
        params = {
          page: (arm.page == undefined) ? this.page : arm.page,
          show: (arm.show == undefined) ? this.show : arm.show,
          order_by: (arm.orderBy == undefined) ? this.orderBy : arm.orderBy,
          type_sort: (arm.sort == undefined) ? this.sort : arm.sort,
        };
      }

      this.orderBy = params.order_by;
      this.sort = params.type_sort;

      if (this.dataSearch.search != undefined) {
        for (const key in this.dataSearch.search) {
          params["search[" + key + "]"] = this.dataSearch.search[key];
        }
      }

      params["filter[div_id]"] = this.data.div_id;

      this.axios.get("/employee", { params: params }).then((response) => {
        this.fields_emp = response.data.data.fields;
        this.data_emp = response.data.data["employee"];
        this.childDataLoaded = true;
      });
    },
  },
};
</script>